/**
 * Generic, module-agnostic tenant registry + URL helpers.
 * Shared by every multi-tenant module (carbon credit is the first consumer).
 */


// Tenant identities. Add a tenant here + its VUE_APP_*_BASE_URL and every module gets it.
export const TENANT_KEYS = {
  DEFAULT: 'default',
  KENYA: 'kenya',
};

export function stripAdminSuffix(url) {
  return (url || '').replace(/\/admin\/?$/, '').replace(/\/+$/, '');
}

export function normalizeAdminUrl(url) {
  return (url || '').replace(/\/+$/, '');
}

export function normalizeApiBase(url) {
  return normalizeAdminUrl(stripAdminSuffix(url));
}

/** Tenants that have an admin URL configured, in priority order. */
export function getTenantDefinitions() {
  return [
    { key: TENANT_KEYS.DEFAULT, adminUrl: process.env.VUE_APP_BASE_URL },
    { key: TENANT_KEYS.KENYA, adminUrl: process.env.VUE_APP_KENYA_BASE_URL },
  ].filter((tenant) => tenant.adminUrl && tenant.adminUrl !== 'undefined');
}

export function tenantKeyFromAdminUrl(adminUrl) {
  const normalized = normalizeAdminUrl(adminUrl);
  const kenyaAdmin = normalizeAdminUrl(process.env.VUE_APP_KENYA_BASE_URL);
  if (kenyaAdmin && normalized === kenyaAdmin) {
    return TENANT_KEYS.KENYA;
  }
  return TENANT_KEYS.DEFAULT;
}

/**
 * The tenant the current session logged into directly. Delegates to the resolver in
 * config/endpoints so routing, token lookup and URL resolution can never disagree —
 * including its LOCAL-DEV rule that .env, not the persisted key, picks the tenant.
 */
export function getPrimaryTenantKey() {
  const cf = typeof localStorage !== 'undefined' ? localStorage.getItem('CF_BASE_URL') : null;
  return tenantKeyFromAdminUrl(cf || process.env.VUE_APP_BASE_URL || '');
}
